import { StatisticsType, UserRole } from "../enums";
import { StatisticsTypeLabels, UserRoleLabels } from "../labels";

export const getEmployeeRoles = [
  {
    id: UserRole.Employee_Instructor_Group_Events,
    name: UserRoleLabels[UserRole.Employee_Instructor_Group_Events],
  },
  {
    id: UserRole.Employee_Instructor,
    name: UserRoleLabels[UserRole.Employee_Instructor],
  },
  {
    id: UserRole.Employee_Manager,
    name: UserRoleLabels[UserRole.Employee_Manager],
  },
];

// The app's role hierarchy as the backend ranks it (UsersUtility.OutranksAll).
// Never compare the enum numbers: the retired Служител (Employee = 20) ranks
// below Мениджър (15).
const roleRanks: Record<UserRole, number> = {
  [UserRole.User]: 0,
  [UserRole.Employee_Instructor_Group_Events]: 1,
  [UserRole.Employee_Instructor]: 2,
  [UserRole.Employee]: 3,
  [UserRole.Employee_Manager]: 4,
  [UserRole.Tenant]: 5,
  [UserRole.GlobalAdmin]: 7,
};

// Whether a session acting as callerRole ranks above targetRole. The backend
// requires it to generate someone's set-password link or to change their email
// and phone (a password reset goes there): a manager can't for the owner or
// another manager. An unknown role fails closed.
export const outranks = (
  callerRole: UserRole | undefined,
  targetRole: UserRole | undefined,
): boolean => {
  const callerRank = callerRole === undefined ? undefined : roleRanks[callerRole];
  const targetRank = targetRole === undefined ? undefined : roleRanks[targetRole];

  return callerRank !== undefined && targetRank !== undefined && callerRank > targetRank;
};

const roleTooltipLine = (role: UserRole, description: string, isLast = false) =>
  `<p style='margin:0${isLast ? "" : " 0 4px"}'><b>${UserRoleLabels[role]}</b> — ${description}</p>`;

// Matches what the backend actually enforces. The old Служител role
// (UserRole.Employee) is retired and no longer offered: role checks are numeric
// (role >= Employee_Manager), and Employee = 20 > Employee_Manager = 15, so it
// had manager-level access. Its users became managers, and Служител is now the
// Employee_Instructor role with the instructor permissions.
export const employeeRolesTooltip =
  "<p style='margin:0 0 8px'>Ролите са подредени от най-много към най-малко права:</p>" +
  roleTooltipLine(
    UserRole.Tenant,
    "пълен достъп, включително управление на зали, Stripe плащания, данни за фактуриране, настройки за НАП и връзки между обектите.",
  ) +
  roleTooltipLine(
    UserRole.Employee_Manager,
    "всичко като собственика, без управление на зали, Stripe плащания, данни за фактуриране, настройки за НАП и връзки между обектите.",
  ) +
  roleTooltipLine(
    UserRole.Employee_Instructor,
    // Only these two reports are pinned to the caller's own rows; Ресурси is
    // studio-wide for every role.
    `календар с всички типове събития, клиенти, продажба на карти и каса. В отчетите „${StatisticsTypeLabels[StatisticsType.Money]}“ и „${StatisticsTypeLabels[StatisticsType.Event]}“ вижда само своите данни, а плановете и номенклатурите само ги преглежда. Няма достъп до служителите и настройките на обекта.`,
  ) +
  roleTooltipLine(
    UserRole.Employee_Instructor_Group_Events,
    "като служителя, но в календара вижда само груповите класове и блокираното време.",
    true,
  );
